import ic_facebook from '../src/Recursos/Iconos/ic_facebook.svg'
import ic_instagram from '../src/Recursos/Iconos/ic_instagram.svg'
import ic_tiktok from '../src/Recursos/Iconos/ic_tiktok.svg'
import pasto_cll_17 from '../src/Recursos/Tiendas/pasto_cll_17.png'
import pasto_cc_unico from '../src/Recursos/Tiendas/pasto_cc_unico.png'
import cra_6 from '../src/Recursos/Tiendas/cra_6.png'
import cra_7 from '../src/Recursos/Tiendas/cra_7.png'
import gran_p from '../src/Recursos/Tiendas/gran_p.png'
import cc_plat from '../src/Recursos/Tiendas/cc_plat.png'

export const LINKWASS = 'https://api.whatsapp.com/send?phone=573217375018&text=Hola%20SyC'

export const REDES = [
    {
        nombre: 'facebook',
        icono: ic_facebook,
        url: 'https://www.facebook.com/SCtiendadeportiva1'
    },
    {
        nombre: 'instagram',
        icono: ic_instagram,
        url: 'https://www.instagram.com/syctiendadeportiva'
    },
    {
        nombre: 'tiktok',
        icono: ic_tiktok,
        url: 'https://www.tiktok.com/@syctiendadeportiva'
    },
]

export const LOCALES = [
    {
        direccion: 'C.C Unico, Local 65',
        img: pasto_cc_unico,
        url: 'https://www.google.com/maps/dir/?api=1&destination=1.205462,-77.260017,190&dir_action=navigate',
        ciudad: 'pasto',
    },
    {
        direccion: 'Calle 17 # 23-03',
        img: pasto_cll_17,
        url: 'https://www.google.com/maps/dir/?api=1&destination=1.212907,-77.279076,190&dir_action=navigate',
        ciudad: 'pasto',
    },
    {
        direccion: 'Cra. 6 No 12-51',
        img: cra_6,
        url: 'https://www.google.com/maps/dir/?api=1&destination=0.824575,-77.637932,190&dir_action=navigate',
        ciudad: 'ipiales',
    },
    {
        direccion: 'Cra. 7 No 14 - 70',
        img: cra_7,
        url: 'https://www.google.com/maps/dir/?api=1&destination=0.825349,-77.640427,190&dir_action=navigate',
        ciudad: 'ipiales',
    },
    {
        direccion: 'C.C. Gran Plaza Local 105',
        img: gran_p,
        url: 'https://www.google.com/maps/dir/?api=1&destination=0.829769,-77.649887,190&dir_action=navigate',
        ciudad: 'ipiales',
    },
    {
        direccion: 'C.C Platinum Local 202',
        img: cc_plat,
        url: 'https://www.google.com/maps/dir/?api=1&destination=0.825166,-77.640404,190&dir_action=navigate',
        ciudad: 'ipiales',
    },
]
